import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { RecoveryCodeIssuedDialogFeature } from './recovery-code-issued-dialog.feature';
import { RecoveryCodeIssuedDialogEffect } from './recovery-code-issued-dialog.effect';

@NgModule({
  imports: [
    RecoveryCodeIssuedDialogFeature,
    EffectsModule.forFeature([ RecoveryCodeIssuedDialogEffect ])
  ],
  exports: [ RecoveryCodeIssuedDialogFeature ]
})
export class RecoveryCodeIssuedDialogModule {}